/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CellaTariffarioDTO { 
    colonna_ordine?: number;
    costo_pasto?: number;
    costo_pasto_multifiglio?: number;
    la_tua?: boolean;
}

